import { IconLink } from './iconLink';

export default IconLink;
